import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/arrow-right.png';
const _hoisted_1 = { class: "left-section" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "notification-badge"
};
const _hoisted_4 = { class: "badge-text" };
const _hoisted_5 = { class: "text-section" };
const _hoisted_6 = { class: "basket-text" };
const _hoisted_7 = { class: "right-section" };
const _hoisted_8 = { class: "amount-section" };
const _hoisted_9 = { class: "amount-text" };
const _hoisted_10 = {
    key: 0,
    src: _imports_0,
    class: "arrow-icon",
    alt: "View basket"
};
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherBasket',
    props: {
        voucherCount: { default: 1 },
        totalAmount: { default: 100.00 },
        basketText: { default: 'View your basket' },
        colour: { default: '#E0EBE3' },
        icon: { default: '@/assets/basket.svg' }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formattedTotal = computed(() => {
            return `£${props.totalAmount.toFixed(2)}`;
        });
        const containerBackgroundColor = computed(() => {
            if (props.voucherCount === 0) {
                return '#F0EEEA';
            }
            else if (props.voucherCount > 1) {
                return '#E0EBE3';
            }
            else {
                return props.colour;
            }
        });
        function handleClick() {
            if (props.voucherCount > 0) {
                emit('click');
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["voucher-basket-container", { 'clickable': _ctx.voucherCount > 0 }]),
                style: _normalizeStyle({ backgroundColor: containerBackgroundColor.value }),
                onClick: handleClick
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["basket-container", { 'single-voucher': _ctx.voucherCount === 1 }])
                    }, [
                        _createElementVNode("img", {
                            src: _ctx.voucherCount > 1 ? require('@/assets/basket.svg') : _ctx.icon,
                            class: _normalizeClass(["basket-icon", { 'single-voucher': _ctx.voucherCount === 1 }]),
                            alt: "Voucher Basket"
                        }, null, 10, _hoisted_2),
                        (_ctx.voucherCount > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.voucherCount), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.basketText), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(formattedTotal.value), 1)
                    ]),
                    (_ctx.voucherCount > 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true)
                ])
            ], 6));
        };
    }
});
